import { useQuery } from '@tanstack/react-query'
import { PaytrieAPI } from '@paytrie/client'

export const useDepositAddress = (transactionId: string | null) => {
  const { data } = useQuery({
    queryKey: ['v2', 'transactions', transactionId],
    queryFn: async () => {
      const res = await PaytrieAPI.getTransaction(transactionId ?? '')
      if (res.status !== 200) {
        throw new Error(`Failed to load transaction (status ${res.status})`)
      }
      return res.data.data
    },
    enabled: !!transactionId,
  })
  return data?.depositAddress ?? null
}
